var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        [
          _c("v-row", [
            !_vm.LoginMode
              ? _c("h3", [_vm._v(_vm._s(_vm.$t("twoFactorScanCodeInfo")))])
              : _c("h3", [_vm._v(_vm._s(_vm.$t("enterOTPCode")))]),
          ]),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  !_vm.LoginMode
                    ? _c("v-img", {
                        attrs: {
                          mb2: "",
                          contain: "",
                          width: 171,
                          height: 171,
                          src: _vm.qrCode,
                        },
                      })
                    : _c("v-icon", { attrs: { size: 90 } }, [
                        _vm._v("mdi-cellphone-lock"),
                      ]),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c("v-text-field", {
                    ref: "loginOtpField",
                    attrs: {
                      "append-icon": _vm.showPass ? "mdi-eye" : "mdi-eye-off",
                      "prepend-icon": "mdi-lock",
                      label: _vm.$t("password"),
                      type: _vm.showPass ? "text" : "password",
                      autocomplete: "off",
                      rules: [_vm.rules.required],
                      counter: 6,
                      maxlength: 6,
                      "ma-0": "",
                      "pa-0": "",
                      required: "",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        _vm.LoginMode
                          ? _vm.sendOTPPin()
                          : _vm.enableTwoFactorAuth()
                      },
                      "click:append": function ($event) {
                        _vm.showPass = !_vm.showPass
                      },
                    },
                    model: {
                      value: _vm.twoFactorPin,
                      callback: function ($$v) {
                        _vm.twoFactorPin = $$v
                      },
                      expression: "twoFactorPin",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              !_vm.LoginMode
                ? _c("mybtn", {
                    attrs: { lable: _vm.$t("activateOTP") },
                    on: { click: _vm.enableTwoFactorAuth },
                  })
                : _c("mybtn", {
                    attrs: { lable: "Login" },
                    on: { click: _vm.sendOTPPin },
                  }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }